enum FundingAccountSelectTypeActionType {
    FUNDING_ACCOUNT_SELECT_TYPE = "FUNDING_ACCOUNT_SELECT_TYPE",
}

export default FundingAccountSelectTypeActionType;